import { IInvestedAssetsNormalized } from '../../store/customerDetail/types';

import { isAssetLiquidity } from './components/AssetTable/liquidities/utils';
import { isAssetStrategy } from './components/AssetTable/strategies/utils';

export const useProductHasFilters = (product?: IInvestedAssetsNormalized) => {
  if (!product) {
    return false;
  }

  const hasFilters =
    !isAssetStrategy(product.marketTypeNormalized) &&
    !isAssetLiquidity(product.marketTypeNormalized);

  return hasFilters;
};
